var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"callbtn",attrs:{"href":`tel:${_vm.phone}`},on:{"click":_vm.onClick}},[_c('base-icon',{attrs:{"name":"phone"}}),_c('span',[_vm._t("default",function(){return [_vm._v("تماس با پشتیبانی")]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }